import { render, staticRenderFns } from "./DiskSimpleTable.vue?vue&type=template&id=e84067e0"
import script from "./DiskSimpleTable.vue?vue&type=script&lang=js"
export * from "./DiskSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports